import { render, staticRenderFns } from "./EditQuestion.vue?vue&type=template&id=7963b805&scoped=true&"
import script from "./EditQuestion.vue?vue&type=script&lang=js&"
export * from "./EditQuestion.vue?vue&type=script&lang=js&"
import style0 from "./EditQuestion.vue?vue&type=style&index=0&id=7963b805&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963b805",
  null
  
)

export default component.exports